import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Download, Check, Loader2 } from "lucide-react";
import { isKept, keepStory, forgetStory } from "@/lib/keptStories";

// « Garder sur la tablette » : le conte et ses voix restent lisibles sans internet.
export default function KeepStoryButton({ story, recs = [], onChange }) {
  const [kept, setKept] = useState(() => isKept(story.id));
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    setBusy(true);
    try {
      if (kept) {
        await forgetStory(story.id);
        setKept(false);
        toast("Conte retiré de la tablette.");
      } else {
        const arsene = await api.get(`/stories/${story.id}/gardien-voice`, { params: { retry: false } }).then((r) => r.data).catch(() => null);
        const arseneUrl = arsene?.status === "ready" ? arsene.url : null;
        await keepStory({ ...story, arsene_url: arseneUrl, kept_recs: recs }, [story.audio_url, arseneUrl, ...recs.map((r) => r.audio_url)]);
        setKept(true);
        toast.success("Conte gardé sur la tablette : il se lira même sans internet.");
      }
      onChange?.();
    } catch { toast.error("Impossible de garder ce conte sur la tablette."); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={toggle} disabled={busy} aria-pressed={kept} data-testid="story-keep-button"
      className={`inline-flex items-center gap-2 h-12 px-5 rounded-full font-patient font-bold border-2 active:scale-95 transition-transform ${kept ? "bg-emerald-700 border-emerald-700 text-white" : "bg-white border-emerald-200 text-emerald-800"}`}>
      {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : kept ? <Check className="w-5 h-5" /> : <Download className="w-5 h-5" />}
      {kept ? "Gardé sur la tablette" : "Garder sur la tablette"}
    </button>
  );
}
